import { Card } from "@omni/ui/components/Card/card";
import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Base = ({ className, children }: Props) => {
    return <Card.Text className={cn(className)}>{children}</Card.Text>;
};
